export const SET_CATEGORY = 'set_category';

